import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { AgsTrailStateResult } from "../../model/results/jackpot-triggertrail-result";
import { AgsResultBuilder } from "./abstract-ags-result-builder";

interface FireworkPublicStateSchema {
    fireworksState: number;
}

export class AgsTrailStateResultBuilder extends AgsResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const publicState = data as FireworkPublicStateSchema;
        return publicState.fireworksState !== undefined;
    }

    public build(record: Record, data: any): Result[] {
        const publicState = data as FireworkPublicStateSchema;

        const agsTrailStateResult = new AgsTrailStateResult();

        agsTrailStateResult.trailLevel = publicState.fireworksState;

        return [agsTrailStateResult];
    }
}
